import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
export default function (map) {

    return {
        mixins: [makeValueData(map), makeRules()],
        props: {
            editable: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            supprime() {
                this.$emit("supprime");
            },
            undo() {
                this.$emit("undo");
            },
            modifie() {
                this.$emit("modifie");
            },
        },
        computed: {
            personneReprise() {
                return "reprise" === this.type;
            },
            personnePhysique() {
                return "physique" === this.type;
            },
            personneMorale() {
                return "morale" === this.type;
            },
            hasSupprime() {
                return this.editable && !!this.$listeners?.supprime && !this.estSupprime;
            },
            hasModifie() {
                return this.editable && !!this.$listeners?.modifie && !this.issueComite && !this.estSupprime && !this.personneReprise;
            },
            hasUndo() {
                return (
                    this.editable &&
                    !!this.$listeners?.undo &&
                    this.estSupprime
                );
            },
            estSupprime() {
                return "supprime" === this.action;
            },
        },
    };
}
